export const INPUT_CLASS = 'block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-gray-900 shadow-xs transition-colors placeholder:text-gray-400 hover:border-gray-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500'

export const LABEL_CLASS = 'flex items-center font-medium text-gray-900'

export const INFOTEXT_CLASS = 'mb-2 max-w-xl text-sm text-gray-600'

export const DESCRIPTION_CLASS = 'mt-1.5 max-w-xl text-xs text-gray-500'
